module.exports = __webpack_public_path__ + "static/media/04.7a8413b7.jpg";